module.exports = __webpack_public_path__ + "img/login-image-01.8f1212db.png";